import { useMutation } from '@tanstack/react-query';
import type { PaymentSchemeEditDto } from '../../models/payment-schemes/payment-scheme-edit.dto';
import apiRequest from '../../services/apiWrapper';
import { PAYMENT_SCHEMES_URL } from '../../utils/constants/urlConstants';

interface CreateSchemeResponse {
  id: string;
}

async function createPaymentScheme(scheme: PaymentSchemeEditDto) {
  return apiRequest.post<PaymentSchemeEditDto, CreateSchemeResponse>(
    PAYMENT_SCHEMES_URL,
    scheme
  );
}

export function useCreatePaymentScheme() {
  return useMutation({
    mutationFn: (scheme: PaymentSchemeEditDto) => createPaymentScheme(scheme),
  });
}
